import { Space, Table } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	DeleteActionSvg,
	EditActionSvg
} from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { CustomUserTableProps } from './type';


const CustomTable: FC<CustomUserTableProps> = (props) => {
	const { Column } = Table;
	const { dataSource, handleTableChange, isLoading, search, performSearchHandler, performFilterHandler, filterValue, openDrawerHandler, setDrawerInfoHandler, setEditSelectedSubCategory, showModal, isSearchCancel, setSearch, setIsSearchCancel, selectedCategory, setSelectedCategory } = props

	
	const updatedDataSource = dataSource?.find((item: any) => item?.id === selectedCategory);
	
	const userPermissions = useSelector(
		(state: any) => state?.userProfile
	);

	const isEditPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Categories',
		permission: ['edit'],
	});

	const isDeletePermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Categories',
		permission: ['delete'],
	});


	const editDataHandler = (categoryObject: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Sub Category');
		setEditSelectedSubCategory(categoryObject);
	};

	// Delete subCategory data handler
	const deleteDataHandler = (categoryObject: any) => {
		setEditSelectedSubCategory(categoryObject);
		showModal();
	};

	return (
		<>
			<div className={`${styles['body']} subCategory-table-pagination `} >
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					performFilterHandler={performFilterHandler}
					filterValue={filterValue}
					title={'Sub Category List'}
					openDrawerHandler={openDrawerHandler}
					isSearchCancel={isSearchCancel}
					setSearch={setSearch}
					setIsSearchCancel={setIsSearchCancel}
					categoryData={dataSource}
					selectedCategory={selectedCategory}
					setSelectedCategory={setSelectedCategory}
				/>

				<Table
					rowKey={(record: any) => record?.userId}
					dataSource={updatedDataSource?.subCategories}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 300px)' }}
				>
					<Column
						title={<p style={{ padding: '0 0px' }}>Sub Category Name</p>}
						dataIndex="subCategoryName"
						key="subCategoryName"
						className="subCategory-column bg-white"
						width={'15%'}
						render={(value: any, record :any) => {
							return <>
							<div>
									{value} {record?.subCategories ? <span style={{paddingLeft: '20px', fontWeight: '700'}}>({record?.subCategories?.length})</span> : ''}
							</div>
							</>
						}
						}

					/>
					{(isEditPermission || isDeletePermission) && (
						<Column
							title="Action"
							dataIndex="action"
							key="action"
							className="bg-white"
							width={'15%'}
							render={(value, data: any) => {
								return (
									<Space size={20}>
										{isEditPermission ? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													editDataHandler(data)
												}
											>
												<EditActionSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">

												<EditActionSvg />
											</div>
										)}

										{isDeletePermission
											? (
												<div
													className="cursor-pointer flex align-center justify-center rounded-action-btn "
													onClick={() =>
														deleteDataHandler(data)
													}
												>
													<DeleteActionSvg />
												</div>
											) : (
												<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn ">
													<DeleteActionSvg />
												</div>
											)}
									</Space>
								);
							}}
						/>
					)}
				</Table>

				{/* <div className={styles['pagination__wrapper']}>
					<Pagination
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
						onChange={onShowSizeChange}
						total={updatedDataSource?.subCategories.length}
						itemRender={(page, type, originalElement) => {
							return (
								<div className={styles['pagination']}>
									{type === 'prev' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<TablePreviousIcon />
											<p
												className={
													styles['pagination__previous']
												}
											>
												Previous
											</p>
										</button>
									) : type === 'next' ? (
										<>
											<button
												className={`${styles['pagination']} ${styles['pagination__button']}`}
											>
												<p
													className={
														styles['pagination__next']
													}
												>
													Next
												</p>
												<TableNextIcon />
											</button>
										</>
									) : (
										originalElement
									)}
								</div>
							);
						}}
					/>
				</div> */}
			</div>
		</>
	);
};

export default CustomTable;
